import { render, staticRenderFns } from "./discoverNorthAmericaMobile.vue?vue&type=template&id=5c231e2a&scoped=true&"
import script from "./discoverNorthAmericaMobile.vue?vue&type=script&lang=js&"
export * from "./discoverNorthAmericaMobile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c231e2a",
  null
  
)

export default component.exports